import { render, staticRenderFns } from "./_CreateOrEdit.vue?vue&type=template&id=1bd1dd6a&scoped=true&"
import script from "./_CreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./_CreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./_CreateOrEdit.vue?vue&type=style&index=0&id=1bd1dd6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd1dd6a",
  null
  
)

export default component.exports